export default function () {
  const body = document.querySelector('body');
  const header = document.querySelector('#menu-header');
  const blackElements = document.querySelectorAll('.black-background-element');
  const blackColorTransitionElements = document.querySelectorAll('.bg-color-transition');

  const manageMenuColor = () => {
    blackElements.forEach((element) => {
      const positionStart = body.offsetHeight - element.offsetHeight - (header.offsetHeight / 2);

      if (window.scrollY >= positionStart) {
        body.classList.add('menu-light');
      } else {
        body.classList.remove('menu-light');
      }
    });
  }

  const manageBodyColor = () => {
    blackColorTransitionElements.forEach((element) => {
      if (element.offsetTop - window.scrollY - (window.innerHeight / 2) < 0) {
        body.classList.add('theme-dark');
      } else {
        body.classList.remove('theme-dark');
      }
    });
  }

  const handleScroll = () => {
    manageMenuColor();
    manageBodyColor();
  };

  window.addEventListener('scroll', handleScroll);
}
